import axios from 'axios';

import { SET_LANGUAGE, SET_SEARCH, GET_ERRORS, SET_CURRENT_USER } from './types';


// Get current profile
export const getCurrentProfile = () => dispatch => {
  axios
    .get('/api/profile')
    .then(res => { }
    )
    .catch(err => { }
    )
}

// Get profile by handle
export const getProfileByHandle = (handle) => dispatch => {
  axios
    .get('/api/profile/handle/' + handle)
    .then(res => { }
    )
    .catch(err => { }
    )
}

// Create Profile
export const createProfile = (profileData, history) => dispatch => {
  axios
    .post('/api/profile', profileData)
    .then(res => history.push('/dashboard'))
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    )
}

// Add experience
export const addExperience = (expData, history) => dispatch => {
  axios
    .post('/api/profile/experience', expData)
    .then(res => history.push('/dashboard'))
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    )
}

// Add education
export const addEducation = (eduData, history) => dispatch => {
  axios
    .post('/api/profile/education', eduData)
    .then(res => history.push('/dashboard'))
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    )
}

// Delete Experience
export const deleteExperience = (id) => dispatch => {
  axios
    .delete('/api/profile/experience/' + id)
    .then(res => { }
    )
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    )
}

// Delete Education
export const deleteEducation = (id) => dispatch => {
  axios
    .delete('/api/profile/education/' + id)
    .then(res => { })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    )
}

// Delete account & profile
export const deleteAccount = () => dispatch => {
  if (window.confirm('Are you sure? This can NOT be undone!')) {
    axios
      .delete('/api/profile')
      .then(res =>
        dispatch({
          type: SET_CURRENT_USER,
          payload: {}
        })
      )
      .catch(err =>
        dispatch({
          type: GET_ERRORS,
          payload: err.response.data
        })
      )
  }
}

export const setLanguage = (lang) => {
  return {
    type: SET_LANGUAGE,
    payload: lang
  }
}

export const setSearch = (str) => {
  return {
    type: SET_SEARCH,
    payload: str
  }
}